<script>
  import { onMount, onDestroy, createEventDispatcher } from 'svelte'
  import { Modal } from 'bootstrap'
  export let large = false

  console.log(large)
  let modalElem, bsModal, sizeClass

  const dispatch = createEventDispatcher()

  $: sizeClass = large ? 'modal-lg' : ''

  onMount(() => {
    bsModal = new Modal(modalElem)
    bsModal.show()
  })

  onDestroy(() => {
    bsModal.hide()
  })
</script>

<div
  class="modal"
  bind:this={modalElem}
  on:hidden.bs.modal={(e) => dispatch('close')}
>
  <div class={`modal-dialog ${sizeClass}`}>
    <div class="modal-content">
      <slot />
    </div>
  </div>
</div>
